import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$locale/_layout/(public)/_public")({
  ssr: true,
});
